var e=(e,t=60)=>e?.length>t?`${e.slice(0,t)}...`:e;export{e as cutTitle};
//# sourceMappingURL=cutTitle.js.map